import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EnvironmentContext } from 'App';
import { faSquareXTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {

    const { environmentData } = useContext(EnvironmentContext);

    let currentTime = new Date();
    let copyrightInfo = `© ${currentTime.getFullYear()} Engineers and Geoscientists BC`;

    let homeUri = environmentData.egbcURI;

    return (
        <div className="footer">
            <div className="k13-row footer-row">
                <div className="k13-column">
                    <div className="footer-acknowledge">
                        Engineers and Geoscientists BC acknowledges that our office is located on the territories of the Coast Salish Peoples, specifically the xʷməθkʷəy̓əm (Musqueam), səlilwətaɬ (Tsleil-Waututh Nation), and Sḵwx̱wú7mesh Úxwumixw (Squamish Nation).
                    </div>
                </div>
                <div className="k13-column">
                    <ul className="footer-menu">
                        <li><a className="icon" href="https://twitter.com/EngGeoBC" title="" target="_blank"><FontAwesomeIcon icon={faSquareXTwitter} /> </a></li>
                        <li><a className="icon" href="https://www.linkedin.com/company/863438/" title="" target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a></li>
                    </ul>
                    <ul className="footer-menu">
                        <li><a className="footer-last-link" href={`${homeUri}/Sitemap`} title="Sitemap">Sitemap</a></li>
                        <li><a href={`${homeUri}/Privacy-Policy`} title="Privacy Notice">Privacy Notice</a></li>
                        <li><a href={`${homeUri}/Terms-and-Conditions`} title="Terms &amp; Conditions">Terms &amp; Conditions</a></li>
                        <li><a href={`${homeUri}/FAQs`} title="FAQs">FAQs</a></li>
                    </ul>
                    <ul className="footer-menu footer-copyright">
                        <li>{copyrightInfo}</li>
                    </ul>
                    <ul className="footer-menu footer-bizname">
                        <li><div className="bizname">“The business name of the Association of Professional Engineers and Geoscientists of the province of BC”</div></li>
                    </ul>
                </div>
            </div>
        </div>

    );
}

export default Footer;
